export default __webpack_public_path__ + "static/media/day-streak-icon.a0eb1a9a.svg";